import { CommonModule }         from '@angular/common';
import { Component }            from '@angular/core';

import { IconsMaterial }        from '@Icons/';
import { MaterialCustomModule } from '@Material/';

import { SideBarBaseComponent } from './sidebar-base.component';


@Component({
    selector:    'qp-sidebar-map',
    templateUrl: 'sidebar-map.component.html',
    styles:      [
        'sidebar-map.component.css'
    ],
    imports:     [
        CommonModule,
        MaterialCustomModule
    ]
})
export class SideBarMapComponent extends SideBarBaseComponent
{
    constructor()
    {
        super(IconsMaterial.map);
    }
}